import { useTranslation } from 'react-i18next';
import useConfigBiogenLincConfig from './BiogenLincConfigGroup.config';

const useBiogenLincConfig = () => {
  const { t } = useTranslation();
  const {
    isVisibleOnBiogenLincConfig,
    eventPromotionalityConfig,
    prcValidationsConfig,
  } = useConfigBiogenLincConfig();

  return {
    isVisibleOnBiogenLincConfig,
    eventPromotionalityConfig,
    prcValidationsConfig,
    t,
  };
};

export default useBiogenLincConfig;
